export var blue = {
    900: '#003977',
    800: '#004B9E',
    700: '#005EC6',
    600: '#0071ED',
    500: '#3294FF',
    400: '#54A6FF',
    300: '#99C9FF',
    200: '#CCE3FB',
    100: '#E5F1FD',
    50: '#F2F8FE',
};
//# sourceMappingURL=blue.js.map